export const ROLES = {
  ADMIN: "ADMIN",
  STOREMANAGERS: "STOREMANAGERS",
  AREAMANAGER: "AREAMANAGER",
  APPADMIN: "APPADMIN",
};
